import { render, staticRenderFns } from "./CardWizard.vue?vue&type=template&id=8d4d8c7e&scoped=true&"
import script from "./CardWizard.vue?vue&type=script&lang=ts&"
export * from "./CardWizard.vue?vue&type=script&lang=ts&"
import style0 from "./CardWizard.vue?vue&type=style&index=0&id=8d4d8c7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4d8c7e",
  null
  
)

export default component.exports